import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';

export default class Tooltip extends Component {
  static propTypes = {
    label: PropTypes.string,
    children: PropTypes.node.isRequired,
  }

  render() {
    const { children, label } = this.props;

    const classNames = ['Tooltip'];

    if (!label) {
      classNames.push('is-disabled');
    }

    return (
      <div className={classNames.join(' ')} data-label={label}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Tooltip.jsx